module.exports = __webpack_public_path__ + "img/13.448c5341.svg";